<template>
    <footer id="footer" class="footer pb-4">
        <div class="footer-head">
            <div class="container">
                <div class="row">
                  <div class="footer-logo-wrap offset-1 offset-lg-4 col-10 col-lg-4 py-1 px-5">
                    <img src="~assets/photo_spot_international_footer_logo.png" class="img-fluid">
                  </div>
                </div>
            </div>
        </div>
        <div id="footer-nav" class="footer-nav py-3">
            <div class="container">
                <div class="row">
                    <div class="col-6 offset-lg-2 col-lg-2">
                        <div class="text-left">
                          <img src="~assets/daicolo_logo.png"class="img-fluid">
                        </div>
                        <ul class="list-unstyled nav-list pt-2">
                            <li class="nav-list-item"><a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[1][9]"/></a></li>
                            <li class="nav-list-item"><a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[1][10]"/></a></li>
                            <li class="nav-list-item"><a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[1][11]"/></a></li>
                        </ul>
                    </div>
                    <div class="col-6 col-lg-2">
                        <ul class="list-unstyled nav-list pt-2">
                            <li class="nav-list-item"><a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[1][12]"/></a></li>
                            <li class="nav-list-item"><a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[1][13]"/></a></li>
                            <li class="nav-list-item"><a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[1][14]"/></a></li>
                            <li class="nav-list-item"><a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[1][15]"/> <i class="fa fa-external-link"></i></a></li>
                            <li class="nav-list-item"><a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[1][16]"/></a></li>
                            <li class="nav-list-item"><a href="javascript:void(0)" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[1][17]"/></a></li>
                        </ul>
                    </div>
                    <div class="col-6 col-lg-2 text-left">
                        <div>
                          <img src="~assets/security_seal.png"class="img-fluid w-50">
                        </div>
                    </div>
                    <div class="col-6 col-lg-2">
                        <p class="mb-0 nav-list-lang-head font-size-lg-06-down font-size-lg-06-up" >
                          <b class=""><trans-text i18nKey="ui[1][18]"/> <i class="fa fa-language"></i></b>
                        </p>
                        <ul class="list-disc-styled nav-list nav-list-lang border-top-0 pb-2">
                            <li class="nav-list-item"><a href="javascript:void(0)" @click="setLnag('ja')">日本語</a></li>
                            <li class="nav-list-item"><a href="javascript:void(0)" @click="setLnag('en')">English</a></li>
                            <li class="nav-list-item"><a href="javascript:void(0)" @click="setLnag('zh-tw')">中文(繁體)</a></li>
                            <!--<li class="nav-list-item"><a href="javascript:void(0)" @click="setLnag('zh-cn')">中文(簡体)</a></li>-->
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import AppTranslation from 'processor/AppTranslation'

  export default {
    components: {
    },
    data () {
      return {
      }
    },
    created(){
    },
    methods:{
      setLnag(langCode){
        AppTranslation.setLang(langCode)
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "~scss/_variables";

  .footer{
    background-color: #fcd599;

   .footer-head{
      background-color: #f4ab7b;
      border-top:2px solid #f19060;
      border-bottom:2px solid #f19060;
    }
    .footer-nav {
      .nav-list {
        .nav-list-item {
          a {
            color: #333;
            font-size: 0.7rem;
          }
        }
        &.nav-list-lang{
          width: 80%;
          @media(min-width: map-get($grid-breakpoints, "sm")) {
            width: 60%;
          }
          @media(min-width: map-get($grid-breakpoints, "md")) {
            width: 40%;
          }
          @media(min-width: map-get($grid-breakpoints, "lg")) {
            width: 90%;
          }

          border:2px solid #B9B2A6;
          /*margin: 0 auto;*/
          li{
            line-height: 1.5rem;
          }
        }
      }
      .nav-list-lang-head{
        i{
          font-size: 1.5em;
        }

      }
    }
  }


</style>



// WEBPACK FOOTER //
// GuestFooter.vue?087ddb94